module.exports = __webpack_public_path__ + "img/banner02.1efd96a0.jpg";